













































































































import Vue from 'vue'
import { Component, Ref } from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";
import {notifySuccess, notifyError, notifyConfirm} from "@/utils/notify-helper";
import {cloneDeep, isEqual} from "lodash";
import {FormRowWings, SelectWings, InputWings} from 'wings-ui-components';
import { ActionLog } from '@/store/auth/types';
import { getTranslatedParams } from '@/utils/notify-utils';

Component.registerHooks([
  'beforeRouteLeave',
])

@Component({components: {SelectWings, FormRowWings, InputWings }})
export default class UserProfile extends Vue {
  @Ref('validator') validator:any;

  @Getter("isADUser") isADUser!: boolean;

  @Action("getTimeZones") actionGetTimeZones: any;
  @Action("getProfile") actionGetItem: any;
  @Action("saveProfile") actionSaveItem: any;
  @Action("changePassword") actionChangePassword: any;
  @Action("authLogout") authLogout: any;
  @Action("actionLog") actionLog: any;

  private item: any =  {
    email: null,
    name: null,
    msisdn: null,
    company: null,
    timeZone: {
      id: null,
      name: null,
    },
  };
  private userPassword: any = {
    newPassword: null,
    newPasswordAgain: null,
  }
  private itemSaved: any;
  private userPasswordSaved: any;
  private timezones: string[] = [];
  logObject: ActionLog = {}

  async created() {
    try {
      let res = await this.actionGetTimeZones();
      this.timezones = res.data

      res = await this.actionGetItem();

      this.item = Object.assign({}, this.item, res.data);
      this.itemSaved = cloneDeep(this.item);
      this.userPasswordSaved = cloneDeep(this.userPassword)
    } catch(error) {
      notifyError(error);
    }
  }

  onSaveItem(): Promise<void> {
    return new Promise( async (resolve, reject) => {
      if (!await this.validator.validate()) {
        notifyError(null, this.validator.errors)
        return
      }
      try {
        const data = {...this.item, timeZone: this.item.timeZone.name}
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: "Editing",
          actionStatus: 'success',
          objectType: "Personal account",
          objectName: localStorage.getItem("lk-username") || '',
          addititionalInfo: getTranslatedParams(data)
        }
        await this.actionSaveItem(data);
        this.itemSaved = cloneDeep(this.item);
        await this.actionLog(this.logObject)

        if (this.userPassword.newPassword) {
          await this.actionChangePassword(this.userPassword);
          await this.authLogout();
          this.$router.push("/login");
        }
        resolve();
      } catch (err) {
        await this.actionLog({...this.logObject, actionStatus: 'failed'})
        reject();
        notifyError(err);
      }
    });
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item, this.itemSaved) || !isEqual(this.userPassword, this.userPasswordSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

};
